import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatInputModule, MatSliderModule } from "@angular/material";

import { AteneaModule, MaterialModule } from "@atenea-cms";
import { PagesRoutes } from "./pages.routes";
import { PageListComponent } from "./page-list/page-list.component";
import { PageFormComponent } from "./page-form/page-form.component";
import { PageService, PageFormService } from "./shared";

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatSliderModule,
    AteneaModule,
    MaterialModule,
    PagesRoutes,
  ],
  declarations: [PageListComponent, PageFormComponent],
  providers: [PageService, PageFormService],
})
export class PagesModule {}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/pages/pages.module.ts